import { useI18n } from "@/context/I18nContext";
import { fmtPrice } from "@/lib/format";

function depthRows(levels, max, side) {
  return levels.map(([price, qty], i) => {
    const w = max > 0 ? Math.min(100, (qty / max) * 100) : 0;
    return (
      <div key={`${side}-${i}-${price}`} className="ob-row flex justify-between">
        <span
          className={`ob-bar ${side === "bid" ? "ob-bar-bid" : "ob-bar-ask"}`}
          style={{ width: `${w}%` }}
        />
        <span
          className="relative z-10 font-mono"
          style={{ color: side === "bid" ? "var(--mq-green)" : "var(--mq-red)" }}
        >
          {fmtPrice(price)}
        </span>
        <span className="relative z-10 text-[var(--mq-text-2)]">
          {Number(qty).toFixed(4)}
        </span>
      </div>
    );
  });
}

export default function OrderBook({ state }) {
  const { t } = useI18n();
  const ob = state?.order_book || {};
  const bids = (ob.bids || []).slice(0, 10);
  const asks = (ob.asks || []).slice(0, 10).reverse();
  const max = Math.max(
    ...bids.map((b) => b[1]),
    ...asks.map((a) => a[1]),
    0.0001
  );
  const spread = ob.spread_pct ?? 0;

  return (
    <div className="mq-panel" data-testid="order-book">
      <div className="mq-panel-header">
        <span className="mq-heading text-sm font-semibold tracking-wider">
          {t("orderBook")} · {state?.symbol || "—"}
        </span>
        <span className="mq-label">Δ {spread.toFixed(3)}%</span>
      </div>
      <div className="grid grid-cols-3 px-4 py-2 mq-label" style={{ borderBottom: "1px solid var(--mq-border)" }}>
        <span></span>
        <span>{t("price")}</span>
        <span className="text-right">{t("qty")}</span>
      </div>
      <div className="px-1 pb-1">
        <div className="pt-1">
          {asks.length === 0 ? (
            <div className="text-xs text-[var(--mq-text-3)] p-2">{t("noData")}</div>
          ) : depthRows(asks, max, "ask")}
        </div>
        <div
          className="py-2 text-center text-xs font-mono"
          style={{ borderTop: "1px solid var(--mq-border)", borderBottom: "1px solid var(--mq-border)" }}
        >
          MID · {ob.mid ? fmtPrice(ob.mid) : "—"}
        </div>
        <div className="pb-1">
          {bids.length === 0 ? (
            <div className="text-xs text-[var(--mq-text-3)] p-2">{t("noData")}</div>
          ) : depthRows(bids, max, "bid")}
        </div>
      </div>
    </div>
  );
}
